import BaseController from "confinus_ui/base_controller";

export default class UnreadItemController extends BaseController {
  public static targets = ["ago"];

  public static values = {
    sentAt: { type: String, default: null },
    threadUid: { type: String, default: null },
  };

  // private declare readonly agoTarget: HTMLElement;
  declare private readonly sentAtValue: any;
  declare private readonly threadUidValue: any;

  public get sentAt(): number {
    return Number(this.sentAtValue);
  }

  public get threadUid(): string {
    return this.threadUidValue!;
  }
}
